import React, { useState } from 'react'
import styled from 'styled-components'
import { useHistory } from 'react-router-dom'
import routes from '../../routes'
import { masterClass } from '../../constants/galleriumVideos'
import LoadIcon from '../../components/LoadIcon'
import Amplitude from '../../utils/amplitudeHelper'
import search from '../../images/mobile/search.png'
import { useDispatch } from 'react-redux'
import { muteMusic, unmuteMusic } from '../../ducks/layout'

const MobileMasterClass = ({ currentUser }) => {
  const history = useHistory()
  const dispatch = useDispatch()
  const [content, setContent] = useState(null)
  const [loading, setLoading] = useState(true)
  const [videos, setVideos] = useState(masterClass)
  const [searchInput, setSearchInput] = useState('')
 
  const showVideo = (item) => {
    setContent(item)
    dispatch(muteMusic())
    Amplitude.playMasterclass(item.title)
  }

  const openForm = () => {
    Amplitude.clickVODForm("masterclass", content.title)
    // window.open( content.form, '_blank')
  }
  const handleBack = () => {
    if (content) {
      setContent(null)
      if (localStorage.getItem('muted') === 'false') {
        dispatch(unmuteMusic())
      }
    } else {
      history.push(routes.lobby)
    }
  }
  const onChangeSearchInput = (e) => {
    setSearchInput(e.target.value)
    if (e.target.value !== '') {
      const updated = masterClass.filter((item) =>
        new RegExp(e.target.value.toLowerCase()).test(item.title.toLowerCase())
      )
      setVideos(updated)
    } else {
      setVideos(masterClass)
    }
  }

  return (
    <Page>
      <div className="outer-wrapper">
        <div className="container">
          <div className="title-container">
            <p className="title">Masterclass</p>
            <div className="back-button" onClick={handleBack}>
              Back
            </div>
          </div>
          {content ? (
            <>
              <div className="video-title">{content.topic}</div>
              <div className="video-title">{content.speaker}</div>
              <div className="video-title">{content.country}</div>

              <div className="video-container">
                {loading && <LoadIcon />}
                <iframe
                  style={{ position: 'absolute', top: 0, left: 0 }}
                  width="100%"
                  height="100%"
                  title="Event Trailer"
                  src={`${content.link}?autoplay=1`}
                  allowFullScreen
                  allow="autoplay; fullscreen"
                  frameBorder="0"
                  onLoad={() => {
                    setLoading(false)
                  }}
                />
              </div>

              <a href={`mailto:${content.form}`} className="video-form d-block py-2" onClick={openForm}>Submit Your Question</a>
              
            </>
            
          ) : 
            <>
              <div className="search-wrapper">
                <input
                  value={searchInput}
                  onChange={onChangeSearchInput}
                  type="text"
                  placeholder="Search"
                  className="search-input"
                />
                <img src={search} className="search-icon" alt="search-icon" />
              </div>
              <div className="list-container">
                {videos.map((item, index) => (
                  <div className="list-item" key={index} onClick={() => showVideo(item)}>
                    <img
                      alt="poster gallery item"
                      src={item.thumbnail}
                      className="list-image"
                    />
                    <button className="item-icon">
                      <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="#26b4a9" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" >
                        <circle cx="12" cy="12" r="10"></circle>
                        <polygon points="10 8 16 12 10 16 10 8"></polygon>
                      </svg>
                    </button>
                  </div>
                ))}
              </div>
            </>
          }
        </div>
      </div>
    </Page>
  )
}

const Page = styled.div`
  background: white;
  height: calc(100% - 60px);
  width: 100vw;
  overflow-y: scroll;
  border-radius: 0px 0px 25px 25px;
  position: absolute;

  .outer-wrapper {
    width: 100%;
  }

  .container {
    width: 90%;
    margin: auto;
  }
  .search-wrapper {
    width: 100%;
    height: 40px;
    border: solid 3px #FFD421;
    border-radius: 30px;
    padding: 0px 10px 0px 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
  }

  .search-input {
    width: 70%;
    font-size: 14px;
    border: none;
  }

  .search-icon {
    height: 20px;
  }
  .title-container {
    margin: 30px 0px 10px 0px;
    height: 100px;
    width: 100%;
    display: flex;
    justify-content: space-between;
  }

  .title {
    width: 80%;
    font-size: 22px;
    font-weight: bold;
    font-style: italic;
    color: black;
    margin: 0;
  }

  .back-button {
    font-size: 12px;
    color: #312384;
    font-weight: bold;
    margin-top: 10px;
  }
  .video-title, .video-form {
    background: #FFD421;
    text-align: center;
    font-weight: 500;
    font-size: 14px;
    width: 100%;
    border: none;
    padding: 0;
    padding-bottom: 4px;
  }
  .video-form {
    text-decoration: none;
    color: black;
  }

  .list-container {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    margin-bottom: 20px;
  }

  .list-item {
    width: 100%;
    padding-bottom: 66.25%;
    position: relative;
  }

  .list-image {
    width: 100%;
    position: absolute;
  }

  .item-icon {
    border: none;
    background: transparent;
    width: 100%;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    svg {
      width: 100%;
      height: 70px;
    }
  }

  .btn-container {
    display: flex;
    justify-content: center;
    margin: 4px 0;
  }
  .gallery-btn {
    background-color: transparent;
    border: none;
    font-size: 15px;
    width: 90%;
    margin: 4px auto;
    font-weight: 500;
    color: #26B4A9;
    svg {
      width: 24px;
      margin-right: 6px;
    }
  }
  .video-container {
    width: 100%;
    height: 0;
    padding-bottom: 56.25%;
    background: black;
    position: relative;
  }
  .topics {
    font-weight: 500;
  }

  @media screen and (min-width: 540px) {
    .outer-wrapper {
      width: 540px;
      margin: auto;
    }
  }
`

export default MobileMasterClass
